// 登录失效重登录
export const LOGIN_AGAIN = 'LOGIN_AGAIN';

// 登录成功之后获取用户信息
export const USER_PROFILE = 'USER_PROFILE';